import React from "react";
import { NavLink } from "react-router-dom";
import AppRoutePath from "../../../../router/AppRoutePath";

import { SIDEBAR_FOOTER_MENU } from "../constants";

const Footer = ({ handleLogout }) => {
  return (
    <div className="d-flex w-100 bgc-2C465C">
      {SIDEBAR_FOOTER_MENU.map((value) => (
        <div key={value.path} className="d-flex w-100 bgc-2C465C align-items-center justify-content-center">
          <NavLink
            to={value.path}
            onClick={value.path === AppRoutePath.LOGIN && handleLogout}
            className="d-flex text-decoration-none text-white btn-block px-3 pt-3 m-0"
          >
            <p>{value.icon}</p>
            <p className="ml-2 d-flex align-self-center">Keluar</p>
          </NavLink>
        </div>
      ))}
    </div>
  );
};

export default Footer;
